<template>
<div class="inside_pages_right">
    <SafetySystemManagement></SafetySystemManagement>
    <!-- 上级下发制度 -->
    <div class="inside_pages_right_content">
        <div class="inside_pages_content_two">
            <div class="content_center_two">
                <el-table  :data="responseData.list" height="100%"  border style="width: 100%">
                    <el-table-column  prop="id" label="编号">
                    </el-table-column>

                    <el-table-column  prop="name1" label="制度名称">
                    </el-table-column>

                    <el-table-column  prop="date1" label="制定时间" width="100">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDate(rowData.row.date1)}}
                        </template>
                    </el-table-column>

                    <el-table-column  prop="name2" label="制定人">
                    </el-table-column>

                    
                    <el-table-column  prop="name3" label="修订记录">
                    </el-table-column>

                    <el-table-column  label="操作" column-key="index" width="300">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" plain>
                                查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content_top_two">
                <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[20, 30, 50, 100]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                prev-text="上一页"
                next-text="下一页"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SafetySystemManagement from '@/components/SafetySystemManagement'
export default {
    name:'',
    components: {SafetySystemManagement},
    props: {},
    data() {
        return {
            delDataList:[],

            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[
                    {
                        id:123,
                        name1: '制度名称测试',
                        name2: '制定人测试',
                        date1: 1593273599,
                        name3:'修订记录测试',
                    }, 
                    {
                        id:123,
                        name1: '制度名称测试',
                        name2: '制定人测试',
                        date1: 1593273599,
                        name3:'修订记录测试',
                    }, 
                    {
                        id:123,
                        name1: '制度名称测试',
                        name2: '制定人测试',
                        date1: 1593273599,
                        name3:'修订记录测试',
                    }, 
                    {
                        id:123,
                        name1: '制度名称测试',
                        name2: '制定人测试',
                        date1: 1593273599,
                        name3:'修订记录测试',
                    }, 
                  
                ],    
            },

            // 请求参数
            requestData :{
                schoolId : this.$store.state.schoolId,
                pageNum : 1,
                pageSize : 20,
                name:null,
                cate:null,
                type:null,
            },

        };
    },
    watch: {
    },
    computed: {},
    methods: {

     
        // 数据显示每页的条数
        handleSizeChange(val) {
            this.requestData.pageSize = val
            this.getDataList()
           
        },

        // 数据翻页
        handleCurrentChange(val) {
            this.requestData.pageNum = val
            this.getDataList()
        },
       
        // 选择数据
        selectDeleteData(val) {
            this.delDataList = []
            for(var i = 0;i<val.length;i++){
                this.delDataList.push(val[i].id)
                
            }
            // console.log(this.delDataList);
        },

        // 删除
        delDataInfo(thisId=0){
            this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if(thisId>=1){
                    var requestData = [thisId]
                }else{

                    if(this.delDataList.length < 1){
                        this.$message({
                            type: 'error',
                            message: '请先选择您要删除的数据'
                        });
                        return false
                    }
                    var requestData = this.delDataList
                }

                
                let res = await  this.$Http.delClassCamera(requestData)
                if(res.code == 200){
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                }else if(res.code == 101){

                } else {
                    this.$message({
                        type: 'error',
                        message: res.messsage
                    });
                }
               
            }).catch(() => {}); 
        },

     
    },
    created() {},
    mounted() {
    }
};
</script>
<style scoped>
</style>